import { useTranslations } from 'next-intl';

export function AuthDivider() {
  const t = useTranslations('common.divider');
  return (
    <div className="text-fg-4 flex items-center gap-2.5 text-xs">
      <span className="bg-border-subtle h-px flex-1" />
      <span>{t('or')}</span>
      <span className="bg-border-subtle h-px flex-1" />
    </div>
  );
}
